import dayjs from 'src/utils/dayjs';

export default () => ({
  investor: '',
  amount: '',
  skipPaymentFlow: false,
  date: dayjs.tz()
});
